var _g, _g2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenDai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    viewBox: "0 0 64 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16Z",
    fill: "#FCD000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_486_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 20.2435 33.6857 24.3131 36.6863 27.3137C39.6869 30.3143 43.7565 32 48 32C52.2435 32 56.3131 30.3143 59.3137 27.3137C62.3143 24.3131 64 20.2435 64 16C64 11.7565 62.3143 7.68687 59.3137 4.68629C56.3131 1.68571 52.2435 0 48 0C43.7565 0 39.6869 1.68571 36.6863 4.68629C33.6857 7.68687 32 11.7565 32 16Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75 15.1241C57.75 13.6221 54.068 12.7421 49.934 12.5341V10.6941H55.709V6.82812H40.29V10.6961H46.066V12.5341C41.932 12.7441 38.25 13.6241 38.25 15.1251C38.25 16.6261 41.931 17.5071 46.066 17.7151V25.1751H49.934V17.7161C54.068 17.5071 57.75 16.6261 57.75 15.1261M49.934 17.0741V17.0661C49.302 17.1041 48.644 17.1171 48 17.1171C47.355 17.1171 46.697 17.1041 46.066 17.0661V17.0741C41.579 16.8471 38.894 15.8601 38.894 15.1261C38.894 14.3931 41.578 13.4061 46.066 13.1791V16.4211C46.685 16.4601 47.329 16.4731 48 16.4731C48.6451 16.4759 49.29 16.4586 49.934 16.4211V13.1791C54.421 13.4051 57.105 14.3931 57.105 15.1261C57.105 15.8591 54.421 16.8461 49.934 17.0741Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3644 17.4244L19.9925 17.4203C18.9345 17.4188 17.9515 17.1557 17.0832 16.5403C15.6721 15.5399 15.0006 14.1065 14.753 12.4448C14.6567 11.7956 14.5459 11.1556 14.2034 10.5858C13.59 9.56455 12.7129 8.99711 11.489 9.00001C10.326 9.00278 9.16301 9.0051 8 9.0071V15.2924C9.10529 15.2951 10.2106 15.2979 11.3159 15.3009C11.6138 15.3019 11.9143 15.3063 12.2089 15.3445C14.8681 15.6889 16.5167 17.8015 16.7905 20.1739C16.7958 20.2196 16.801 20.2655 16.8062 20.3115L16.8063 20.3123C16.8599 20.7847 16.9143 21.2645 17.0566 21.7122C17.3913 22.7677 18.5287 23.7439 20.0545 23.7294C21.1576 23.7189 22.261 23.7165 23.3644 23.7171V17.4244Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.7303C9.15012 23.73 10.3002 23.7295 11.4503 23.7285C11.683 23.7285 11.9205 23.7227 12.1479 23.6787C13.7792 23.3632 14.7336 21.8975 14.7079 20.5478C14.676 18.8372 13.2925 17.4189 11.5848 17.4198C10.3899 17.4207 9.19495 17.4216 8 17.4225V23.7303Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3644 9.00577C22.2119 9.00492 21.0594 9.00412 19.9069 9.00341C19.7231 9.00341 19.5358 9.01696 19.3559 9.05372C17.7991 9.3701 16.6212 10.8127 16.8529 12.5706C17.0808 14.3 18.6157 15.3203 20.0539 15.3029C21.1573 15.2894 22.2608 15.2831 23.3644 15.2809V9.00577Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_486_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDai);
export default __webpack_public_path__ + "static/media/token_dai.ca12b0ac7285f0ae1c1089242ccf1b4a.svg";
export { ForwardRef as ReactComponent };